export abstract class Operator {
  abstract evaluate(left: any, right: any): boolean;
}
